import { useEffect, useState } from "react";
import api, { fmtIDR, apiErr } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { toast } from "sonner";
import { CalendarCheck } from "lucide-react";

// Bulk entry of days present per employee; absence deduction = (gaji pokok + tunjangan tetap) / hari kerja × hari tidak masuk.
export function AttendanceDialog({ clientId, year, month, rows, onDone }) {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({});
  useEffect(() => {
    if (open) setF(Object.fromEntries(rows.map((r) => [r.id, { present_days: r.present_days ?? "", work_days: r.work_days ?? "" }])));
  }, [open, rows]);
  const set = (id, k, v) => setF((s) => ({ ...s, [id]: { ...s[id], [k]: v } }));
  const fillAll = () => setF((s) => Object.fromEntries(rows.map((r) => [r.id, { ...s[r.id], present_days: "" }])));
  const save = async () => {
    try {
      const items = rows.map((r) => ({ id: r.id, ...f[r.id] }));
      const { data } = await api.post("/payroll/attendance", { client_id: clientId, year, month, items });
      toast.success(`Kehadiran ${data.updated} karyawan disimpan & dihitung ulang`); setOpen(false); onDone();
    } catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  const auto = rows[0]?.work_days_auto;
  return (
    <>
      <Button size="sm" variant="outline" onClick={() => setOpen(true)} disabled={!rows.length} data-testid="monthly-attendance-btn"><CalendarCheck className="h-4 w-4 mr-1" />Input Hari Masuk</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-3xl max-h-[90vh] overflow-auto">
          <DialogHeader><DialogTitle>Hari Masuk Karyawan</DialogTitle>
            <DialogDescription className="text-xs">Hari kerja otomatis bulan ini: {auto ?? "—"} hari (sesuai pengaturan 5/6 hari kerja). Kosongkan Hari Masuk = masuk penuh. Potongan absensi = (gaji pokok + tunjangan tetap) ÷ hari kerja × hari tidak masuk, dipotong sebelum PPh 21.</DialogDescription></DialogHeader>
          <div className="flex justify-end"><Button variant="ghost" size="sm" onClick={fillAll} data-testid="attendance-fill-full">Set semua masuk penuh</Button></div>
          <div className="overflow-auto rounded-md border border-border">
            <Table>
              <TableHeader><TableRow className="bg-secondary/50"><TableHead>Karyawan</TableHead><TableHead className="w-32">Hari Kerja</TableHead><TableHead className="w-32">Hari Masuk</TableHead><TableHead className="text-right">Potongan Saat Ini</TableHead></TableRow></TableHeader>
              <TableBody>{rows.map((r) => (
                <TableRow key={r.id} data-testid={`attendance-row-${r.id}`}>
                  <TableCell className="text-sm">{r.name}<span className="block text-[10px] text-muted-foreground">{r.employee_code}</span></TableCell>
                  <TableCell><Input type="number" min="0" className="num h-8" placeholder={String(r.work_days_auto ?? auto ?? "")} value={f[r.id]?.work_days ?? ""} onChange={(e) => set(r.id, "work_days", e.target.value)} data-testid={`attendance-work-${r.id}`} /></TableCell>
                  <TableCell><Input type="number" min="0" className="num h-8" placeholder="penuh" value={f[r.id]?.present_days ?? ""} onChange={(e) => set(r.id, "present_days", e.target.value)} data-testid={`attendance-present-${r.id}`} /></TableCell>
                  <TableCell className="num text-right text-xs">{fmtIDR(r.absence_deduction || 0)}</TableCell>
                </TableRow>))}</TableBody>
            </Table>
          </div>
          <DialogFooter><Button onClick={save} data-testid="attendance-save">Simpan & Hitung</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
